import { clsx, type ClassValue } from 'clsx';

/**
 * Class-name composer for Tailwind components. Thin wrapper around `clsx`.
 *
 * Why not tailwind-merge? — Tailwind v4 with the design-tokens preset uses
 * semantic utilities (`bg-bg`, `text-ink`, `bg-accent`, …) rather than raw
 * arbitrary classes, so conflicts between later overrides are rare. If a
 * component needs to honour a caller's `className` override on a property
 * the component itself sets, twMerge will be added then — not before.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
